/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Blog_Count_OneInputs */

const en_blog_count_one = /** @type {(inputs: Blog_Count_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} article`)
};

const lv_blog_count_one = /** @type {(inputs: Blog_Count_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} raksts`)
};

/**
* | output |
* | --- |
* | "{count} article" |
*
* @param {Blog_Count_OneInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_count_one = /** @type {((inputs: Blog_Count_OneInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Count_OneInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_count_one(inputs)
	return en_blog_count_one(inputs)
});